import { Query } from '@firebase/firestore-types';

export class Page<T=any> {
  total: number;
  count: number;
  current: number;
  size: number;
  _embedded: any;
  items: T[];
};

export interface Filter{
  where(query:Query):Query;
  addParams(params:any): void;
}

export class NoopFilter implements Filter{
  where(query:Query): Query{
    return query;
  }
  addParams(): void{

  }
}

export enum SortOrder{
  asc = "asc",
  desc = "desc"
};

export class PageSpecs<T extends Filter> {
  size: number;
  page: number;
  sort: string;
  order: SortOrder = SortOrder.asc;
  filter: T;
  collectionName: string;
  public toMap(): any{
    let params = {
       size: this.size,
       page: this.page,
       sort: this.sort,
       order: this.order
     };
     this.filter.addParams(params);
     return params;
  }
};
